import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Typography, Box, useMediaQuery, Divider } from '@mui/material';
import { theme } from '../Template';
import ImgLazyLoad from 'src/screens/WhiteLabels/Templates/shared/components/ImgLazyLoad'
import SocialIcons from '../../shared/components/SocialIcons';
import { useCompanyData } from '../../shared/contexts/DataContext';
import Logo from 'src/assets/images/white-logo.png';
import CardIcons from 'src/assets/images/cardIcons.png'

const Footer = () => {
  const matches = useMediaQuery(theme.breakpoints.up('sm'));
  const { data } = useCompanyData();
  const { pathname:url } = useLocation();
  const { mainColor ,t ,isRTL ,companyDomain, termsLink, privacyLink, refundLink } = data || {};
  const companyId = data.companyData?.id;
  const { facebookPage, instagramPage, twitterPage } = data.companyData || {};
  const navItem =  [{title:t && t('companyPage.home'),link: companyDomain ? '/' : url},{title:t && t('companyPage.services'),link: companyDomain ? '/temp/services' : `${url}/temp/services`},{title:t && t('companyPage.contact'),link: companyDomain ? `/temp/contact` : `${url}/temp/contact`}]

  const footerLinks = [
    {...(termsLink && {...{isPath:true,link:companyDomain ? '/temp/terms' : `${url}/temp/terms`,label:'Terms and Condition'}})},
    {...(privacyLink && {...{link: privacyLink,label:'Privacy Policy'}})},
    {...(refundLink && {...{link: refundLink,label:'Refund Policy'}})},
  ];

  return (
    <Box style={{padding:'10px 0px'}} bgcolor={mainColor ? mainColor : "#089B9B"}>
      {/* menu buttons */}
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        textAlign="center"
        justifyContent="space-evenly"
        color="white"
        width="calc(100% - 60px)"
        padding="16px 30px"
      >
        {React.Children.toArray(navItem.map(v=> {
          return(
            <Typography>
              <Link to={v.link}>
                {v.title}
              </Link>
            </Typography>
          )
        }))}
      </Box>

      <Divider style={{ backgroundColor: '#C7C5CD', margin: 'auto' }} />

      {/* term and condition */}
      <Box
        display="flex"
        flexDirection={matches ? 'row' : 'column'}
        textAlign="center"
        alignItems="center"
        justifyContent="space-between"
        color="#000"
        width="calc(100% - 60px)"
        padding="10px 30px"
      >
        <Box
        display="flex"
        flexDirection='row'
        textAlign="center"
        alignItems="center"
        width={matches ? "40%" : "100%"}
        justifyContent={matches ? 'unset' : 'center'}
        visibility={footerLinks.length ? 'visible' : 'hidden'}
        >
          {
          React.Children.toArray(footerLinks.map((v,index)=> {
            if(v.link) {
              return (
                <>
                {v.isPath ? <Link to={v.link} style={{textDecoration:'none',color:'#fff',cursor:'pointer',fontSize: matches ? '13px' : '10px' }}>{v.label}</Link>: <a href={v.link} target="_blank" style={{textDecoration:'none',color:'#fff',cursor:'pointer',fontSize: matches ? '13px' : '10px' }}>{v.label}</a>} 
                {index !== footerLinks.length -1 ? <Divider style={{width:'12px',backgroundColor:'#fff',margin:'0px 10px'}} /> : null}
                </>
              )
            }
          }))
          }
        </Box>

        <Box 
          width={matches ? "30%" : "100%"}
          display="flex"
          flexDirection="column"
          justifySelf={matches ? "flex-end" : "center"}
          alignItems={matches ? "flex-end": "center"}
          pt={matches ? '0px' : '3px'}
        >
          <div style={{width:'250px'}}>
            <ImgLazyLoad>
              <img src={CardIcons} alt='card' style={{width:'100%',height:'100%'}}/>
            </ImgLazyLoad>
          </div>
        </Box>

      </Box>

      <Divider style={{ backgroundColor: '#C7C5CD', margin: 'auto' }} />
        
      {/* copyright and powered by */}
      <Box
        display="flex"
        width="calc(100% - 60px)"
        flexDirection={matches ? 'row' : 'column'}
        textAlign="center"
        alignItems="center"
        justifyContent="space-between"
        color="white"
        style={{padding:'16px 30px'}}
      >
        <SocialIcons
          color={mainColor ? mainColor : "#089B9B"}
          bgcolor="#fafafa"
          facebookLink={facebookPage}
          instagramLink={instagramPage}
          twitterLink={twitterPage}
        />

      <Box
        color="#fff"
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection={isRTL == 'ar' ? 'row-reverse' : 'row'}
      >
        <Typography
          align="center"
          variant="subtitle2"
          style={{ marginRight: '0.6em' }}
          dir="ltr"
        >
          {t && t('companyPage.copyright',{year: new Date().getFullYear()})}
        </Typography>
        
        <a
          href="https://www.selynk.com/"
          rel="noopener noreferrer"
          target="_blank"
          style={{ textDecoration: 'none' }}
        >
          <Box
            height="25px"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <ImgLazyLoad>
              <img src={Logo} alt="logo" style={{ height: '100%' }} />
            </ImgLazyLoad>
          </Box>
        </a>
      </Box>
      </Box>
    </Box>
  );
};

export default Footer;